export default __webpack_public_path__ + "static/media/Snowing_00.258d7302.png";